import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['noData', 'item']

  itemTargetConnected() {
    this.noDataTarget.remove()
  }
}
